import React from 'react';
import type { PortalUser } from '../../types/portal';
import { displayName, initials } from '../../utils/portalFormat';
export function Avatar({
  user,
  size = 'md'
}: {
  user: PortalUser;
  size?: 'sm' | 'md';
}) {
  const dims = size === 'sm' ? 'h-7 w-7 text-[11px]' : 'h-9 w-9 text-[13px]';
  return <span className={`inline-flex shrink-0 items-center justify-center rounded-full font-semibold ${dims} ${user.isInternal ? 'bg-gold text-charcoal' : 'bg-line text-ink'}`} title={displayName(user)} aria-hidden="true" data-id="element-936" data-mp="ie9yikgn5sf9">
      {initials(user)}
    </span>;
}